import {
    useStyles,
    ProfileNavigation,
    Flex,
    useAppDisplayModeContext,
    pxToRem,
    pxArrayToRem,
} from '@archipro-design/aria';
import * as S from './BoardListFilterNav.style';
import { useCurrentTabPath } from '~/modules/professional/hook/use-current-tab-path';

import {
    Link,
    useLoaderData,
    useLocation,
    useSearchParams,
} from '@remix-run/react';
import type { loader } from '~/routes/_app.member.design-boards.$boardUrlSegment._index';
import {
    getSideNavLinksByPins,
    isValueOfObject,
} from '~/modules/design-board/util';
import {
    PIN_TITLE_AND_TYPE,
    PIN_TYPE_PARAM_NAME,
} from '~/modules/design-board/config';
import { useEffect, useRef } from 'react';
import { DesignBoardPinTargetType } from 'generated/graphql';

interface BoardDetailFilterNavProp {
    pinCount: number;
}

export const BoardDetailFilterNav = ({
    pinCount,
}: BoardDetailFilterNavProp) => {
    const currentTabPath = useCurrentTabPath();
    const { css } = useStyles({ currentTabPath });
    const location = useLocation();
    const { mobile } = useAppDisplayModeContext();
    const selectedButtonRef = useRef<HTMLDivElement>(null);

    const { pinCounts, targetType } = useLoaderData<typeof loader>();
    const sideNavItems = getSideNavLinksByPins(pinCounts, mobile);

    const [searchParams] = useSearchParams();
    const pinTargetType = searchParams.get(
        PIN_TYPE_PARAM_NAME
    ) as DesignBoardPinTargetType;
    const isValidPinType = isValueOfObject(
        pinTargetType,
        DesignBoardPinTargetType
    );
    if (
        isValidPinType &&
        !sideNavItems.find((item) => item.type === pinTargetType)
    ) {
        const item = PIN_TITLE_AND_TYPE.find(
            (item) => item.type === pinTargetType
        );
        item &&
            sideNavItems.push({
                title: item.title,
                link: `?${PIN_TYPE_PARAM_NAME}=${item.type}`,
                type: item.type,
            });
    }

    const navItemButtons = sideNavItems.map((item) => {
        const isSelected = location.search.includes(PIN_TYPE_PARAM_NAME)
            ? location.search.includes(item.link)
            : item.link === `?${PIN_TYPE_PARAM_NAME}=${targetType}`;

        return {
            children: item.title as string,
            as: Link,
            to: item.link,
            preventScrollReset: true,
            ref: isSelected ? selectedButtonRef : null,
            selected: isSelected,
        };
    });

    useEffect(() => {
        if (!selectedButtonRef.current) return;
        selectedButtonRef.current.scrollIntoView({
            inline: 'center',
            block: 'center',
        });
    }, [location.search]);

    return pinCount > 0 ? (
        <Flex className={css(S.MobileFilterWarp)}>
            <ProfileNavigation
                items={navItemButtons}
                variables={{
                    filterButtonMinWidth: pxToRem(46),
                    buttonPadding: pxArrayToRem([12, 13.5]),
                    buttonHeight: pxToRem(38),
                }}
            />
        </Flex>
    ) : (
        <div className={css(S.MobileFilterDivider)}></div>
    );
};
